import Loading from 'vue-loading-overlay'

export default {
  name: 'StockBacklogs',

  components: {
    Loading
  },

  data() {
    return {
      isLoading: false,
      loader: 'bars',
      opacity: 0.9,

      totalSent: 0,
      checkedCachedCompanies: '',
      offlineWebhooks: [],
      onlineWebhooks: []
    }
  },

  methods: {
    redirect(route) {
      this.$router.push(route)
    },

    async readParams() {
      this.checkedCachedCompanies = this.$route.query.checkedCachedCompanies ? this.$route.query.checkedCachedCompanies : ''

      try {
        this.offlineWebhooks = this.$route.query.offlineWebhooks ? JSON.parse(this.$route.query.offlineWebhooks) : []
        this.onlineWebhooks = this.$route.query.onlineWebhooks ? JSON.parse(this.$route.query.onlineWebhooks) : []
        this.totalSent = this.$route.query.counter ? parseInt(this.$route.query.counter) : 0
      } catch (error) {
        console.error('Error parsing route query data:', error)
        this.offlineWebhooks = []
        this.onlineWebhooks = []
        this.totalSent = 0
      }
    }
  },

  beforeMount() {
    this.readParams()
  }
}
